export const randomBytes = (n: number) => new Uint8Array(n);
export const createCipheriv = () => ({ update: () => new Uint8Array(0), final: () => new Uint8Array(0) });
export const createDecipheriv = () => ({ update: () => new Uint8Array(0), final: () => new Uint8Array(0) });
export const createHash = () => ({ update: () => ({ digest: () => '' }) });
export default { randomBytes, createHash, createCipheriv, createDecipheriv };
